<template>
	<div>
		<div v-for="(contact, contactIndex) in contacts"
				 :key="`contact_${contactIndex}`">

			<!-- Start of Student Contact Information section -->
			<div class="row">
				<panel-basic :title="`${contact.CONTACT_DESC} - ${contact.FIRST_NAME} ${contact.LAST_NAME}`"
											:id="`contacts_${contactIndex}`"
											:collapsable="true"
											class="contact-header rounded-top"
											panel-class="full-height"
											style="border-radius: 25px;"
											:helpText="helpText">
					<div class="col-xs-12 col-md-4" style="min-height: 95px;" v-if="showContactNameFlag">
						<ValidationProvider ref="provider">
							<label for="title">{{ titleText }}</label>
							<input type="text"
										class="form-control"
										name="title"
										:aria-label="titleText"
										v-model="contact.TITLE"
										:disabled="isReadOnly"
										maxlength="10" />
						</ValidationProvider>
					</div>
					<div class="col-xs-12 col-md-4" style="min-height: 95px;" v-if="showContactNameFlag">
						<ValidationProvider ref="provider">
							<label for="middleName">{{ middleNameText }}</label>
							<input type="text"
										class="form-control"
										name="middleName"
										maxlength="40"
										:aria-label="middleNameText"
										v-model="contact.MIDDLE_NAME"
										:disabled="isReadOnly" />
						</ValidationProvider>
					</div>
					<div class="col-xs-12 col-md-4" style="min-height: 95px;" v-if="showLivesWithFlag">
						<ValidationProvider ref="provider">
							<label for="livesWithStudent">{{ contactLivesWithStudentText }}</label>
							<select class="form-control"
											:aria-label="contactLivesWithStudentText"
											v-model="contact.LIVES_WITH_FLG"
											:disabled="isReadOnly">
								<option value="Y">{{ yesText }}</option>
								<option value="N">{{ noText }}</option>
							</select>
						</ValidationProvider>
					</div>

					<div class="col-xs-12 col-md-4" style="min-height: 95px;" v-if="showReleaseToFlag">
						<ValidationProvider ref="provider">
							<label for="releaseStatus">{{ releaseStatusText }}</label>
							<select class="form-control"
											:aria-label="releaseStatusText"
											v-model="contact.RELEASE_STATUS"
											:disabled="isReadOnly">
								<option v-for="release in releaseStatus" :key="release.RELEASE_STATUS_CODE" :value="release.RELEASE_STATUS_CODE">{{release.RELEASE_STATUS_DESC}}</option>
							</select>
						</ValidationProvider>
					</div>

					<div class="col-xs-12 col-md-12" v-if="showAddressFlag">
						<div class="row">
							<div class="col-xs-12 col-md-6" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="address_1">{{ addressOneText }}</label>
									<input name="address_1"
												class="form-control"
												:aria-label="addressOneText"
												type="text"
												v-model="contact['ADDRESS_1']"
												:disabled="isReadOnly"
												maxlength="40">
								</ValidationProvider>
							</div>
							<div class="col-xs-12 col-md-6" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="address_2">{{ addressTwoText }}</label>
									<input name="address_2"
												class="form-control"
												:aria-label="addressTwoText"
												type="text"
												v-model="contact['ADDRESS_2']"
												:disabled="isReadOnly"
												maxlength="40">
								</ValidationProvider>
							</div>
							<div class="col-xs-12 col-md-4" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="city">{{ cityText }}</label>
									<input name="city"
												class="form-control"
												:aria-label="cityText"
												type="text"
												v-model="contact['ADDRESS_CITY']"
												:disabled="isReadOnly"
												maxlength="40">
								</ValidationProvider>
							</div>

							<div class="col-xs-12 col-md-3" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="state">{{ stateText }}</label>
									<select class="form-control"
													:aria-label="stateText"
													v-model="contact['ADDRESS_STATE']"
													:disabled="isReadOnly">
										<option v-for="state in states" :key="state.STATE_CODE" :value="state.STATE_CODE">
											{{ state.STATE_DESC }}
										</option>
									</select>
								</ValidationProvider>
							</div>
							<div class="col-xs-12 col-md-3" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="zip">{{ zipCodeText }}</label>
									<input name="zipCode"
												class="form-control"
												:aria-label="zipCodeText"
												type="text"
												v-model="contact['ADDRESS_ZIP']"
												:disabled="isReadOnly"
												maxlength="5">
								</ValidationProvider>
							</div>

							<div class="col-xs-12 col-md-2" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="zipExt">{{ zipCodeExtText }}</label>
									<input name="zipCodeExt"
												class="form-control"
												:aria-label="zipCodeExtText"
												:maxlength="zipExtMaxLength"
												type="text"
												v-model="contact['ADDRESS_ZIP_EXT']"
												:disabled="isReadOnly">
								</ValidationProvider>
							</div>

							<div class="col-xs-12 col-md-3" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="township">{{ townshipText }}</label>
									<select class="form-control"
													:aria-label="townshipText"
													v-model="contact['TOWNSHIP_CODE']"
													:disabled="isReadOnly">
										<option v-for="township in townships" :key="township.TOWNSHIP_CODE" :value="township.TOWNSHIP_CODE">
											{{ township.TOWNSHIP_DESC }}
										</option>
									</select>
								</ValidationProvider>
							</div>

							<div class="col-xs-12 col-md-3" style="min-height: 95px;">
								<ValidationProvider ref="provider">
									<label for="county">{{ countyText }}</label>
									<select class="form-control"
													:aria-label="countyText"
													v-model="contact['ADDRESS_COUNTY']"
													:disabled="isReadOnly">
										<option v-for="county in counties" :key="county.COUNTY_CODE" :value="county.COUNTY_CODE">
											{{ county.COUNTY_DESC }}
										</option>
									</select>
								</ValidationProvider>
							</div>
						</div>
					</div>
					<!-- Start of Phone Data -->
					<div class="col-xs-12" v-for="(phone, phoneIndex) in 5" :key="`phone_${phoneIndex}`" v-if="showPhoneNumbersFlag">
						<panel-basic :title="`Phone ${+phoneIndex + 1}`"
												 :id="`contact_${contactIndex}_phone_numbers`"
												 :collapsable="true"
												 :defaultCollapsed="true"
												 panelClass="full-height"
												 style="border-radius: 25px 25px 0 0;"
												>
							<div class="row">
								<div class="col-xs-12 col-md-4">
									<ValidationProvider ref="provider">
										<label :for="`number_${phoneIndex}`">{{ numberText }}</label>
										<input :name="`number_${phoneIndex}`"
													class="form-control"
													:aria-label="`phone number ${+phoneIndex + 1}`"
													type="text"
													v-model="contact[`PHONE_${+phoneIndex + 1}`]"
													:disabled="isReadOnly"
													 maxlength="20">
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider ref="provider">
										<label :for="`ext_${phoneIndex}`">{{ extensionText }}</label>
										<input :name="`ext_${phoneIndex}`"
													class="form-control"
													:aria-label="`extension ${+phoneIndex + 1}`"
													type="text"
													v-model="contact[`PHONE_${+phoneIndex + 1}_EXT`]"
													:disabled="isReadOnly"
													maxlength="10">
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider ref="provider">
										<label :for="`type_${phoneIndex}`">{{ typeText }}</label>
										<select :name="`type_${phoneIndex}`"
														class="form-control"
														:aria-label="`phone type ${+phoneIndex + 1}`"
														v-model="contact[`PHONE_${+phoneIndex + 1}_TYPE_CODE`]"
														:disabled="isReadOnly">
											<option value="Cell">{{ cellPhoneText }}</option>
											<option value="Fax">{{ faxNumberText }}</option>
											<option value="Home">{{ homePhoneText }}</option>
											<option value="Pager">{{ pageNumberText }}</option>
											<option value="Work">{{ workPhoneText }}</option>
										</select>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider ref="provider">
										<label :for="`unlisted_${phoneIndex}`">{{ unlistedText }}</label>
										<select :name="`unlisted`"
														class="form-control"
														:aria-label="`phone unlisted ${+phoneIndex + 1}`"
														v-model="contact[`PHONE_${+phoneIndex + 1}_UNLISTED_FLG`]"
														:disabled="isReadOnly">
											<option value="N">{{ noText }}</option>
											<option value="Y">{{ yesText }}</option>
										</select>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider ref="provider">
										<label :for="`voice_calls_${phoneIndex}`">{{ receivesVoiceCallsText }}</label>
										<select :name="`voice_calls_${phoneIndex}`"
														class="form-control"
														:aria-label="`receive phone calls ${+phoneIndex + 1}`"
														v-model="contact[`PHONE_${+phoneIndex + 1}_VOICE_FLG`]"
														:disabled="isReadOnly">
											<option value="Y">{{ yesText }}</option>
											<option value="N">{{ noText }}</option>
										</select>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider ref="provider">
										<label :for="`text_${phoneIndex}`">{{ receivesTextMessages }}</label>
										<select :name="`text_${phoneIndex}`"
														class="form-control"
														:aria-label="`receive text ${+phoneIndex + 1}`"
														v-model="contact[`PHONE_${+phoneIndex + 1}_SMS_FLG`]"
														:disabled="isReadOnly">
											<option value="Y">{{ yesText }}</option>
											<option value="N">{{ noText }}</option>
										</select>
									</ValidationProvider>
								</div>

								<div class="col-xs-12 col-md-4">
									<ValidationProvider ref="provider">
										<label :for="`call_order_${phoneIndex}`">{{ emergencyCallOrder }}</label>
										<select :name="`call_order_${phoneIndex}`"
														class="form-control"
														:aria-label="`call order ${+phoneIndex + 1}`"
														v-model="contact[`PHONE_${+phoneIndex + 1}_ECO`]"
														:disabled="isReadOnly">
											<option value=""></option>
											<option :value="val" v-for="val in 99" :key="`call_order_${phoneIndex}_${val}`">{{ val }}</option>
										</select>
									</ValidationProvider>
								</div>
							</div>
						</panel-basic>
					</div>
					<!-- End of Phone Data -->
					<!-- Start of Email Addresses -->
					<div class="col-xs-12 col-md-4"
							 v-for="email in 3"
							 style="min-height: 95px;"
							 :key="`email_${email}`"
							 v-if="showEmailAddressFlag">
						<ValidationProvider ref="provider">
							<label :for="`email_${email}`">{{ emailText }} {{ email }}</label>
							<input type="text"
										class="form-control"
										:aria-label="`Email Address ${email} input`"
										v-model="contact[`EMAIL_ADDRESS_${email}`]" :disabled="isReadOnly" maxlength="200" />
						</ValidationProvider>
					</div>
					<!-- End of Email Addresses -->
					<div class="col-xs-12 col-md-4" style="min-height: 95px;" v-if="showEmployerOccupationFlag">
						<ValidationProvider ref="provider">
							<label for="occupation">{{ occupationText }}</label>
							<input type="text"
										class="form-control"
										:aria-label="occupationText"
										name="occupation"
										v-model="contact.OCCUPATION" :disabled="isReadOnly" maxlength="50"/>
						</ValidationProvider>
					</div>
					<div class="col-xs-12 col-md-4" style="min-height: 95px;" v-if="showEmployerOccupationFlag">
						<ValidationProvider ref="provider">
							<label for="employer">{{ employerText }}</label>
							<input type="text"
										class="form-control"
										:aria-label="employerText"
										name="employer"
										v-model="contact.EMPLOYER" :disabled="isReadOnly" maxlength="75" />
						</ValidationProvider>
					</div>
					<br :key="`contacts_br_${contactIndex}`" />
				</panel-basic>
			</div>
			<!-- End of Student Contact Information section -->
		</div>
	</div>
</template>

<script>
	import PanelBasic from '../panels/PanelBasic.vue';
	import SapphireToggle from '../SapphireToggle/SapphireToggle.vue';

	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

	import { ValidationProvider } from 'vee-validate';
	import { VTooltip } from 'v-tooltip';
	import '../../imports/fontAwesome.js';

	export default {
		name: 'SISStudentContacts',
		props: {
			contacts: {
				type: Array,
				required: true,
			},
			counties: {
				type: Array,
				default: () => [],
			},
			releaseStatus: {
				type: Array,
				default: () => [],
			},
			townships: {
				type: Array,
				default: () => [],
			},
			states: {
				type: Array,
				default: () => [],
			},
			showContactNameFlag: {
				type: Boolean,
				default: true,
			},
			showAddressFlag: {
				type: Boolean,
				default: true,
			},
			showEmailAddressFlag: {
				type: Boolean,
				default: true,
			},
			showLivesWithFlag: {
				type: Boolean,
				default: true,
			},
			showReleaseToFlag: {
				type: Boolean,
				default: true,
			},
			showPhoneNumbersFlag: {
				type: Boolean,
				default: true,
			},
			showEmployerOccupationFlag: {
				type: Boolean,
				default: true,
			},
			helpText: {
				type: String,
				default: "",
			},
			titleText: {
				type: String,
				default: "Title"
			},
			middleNameText: {
				type: String,
				default: "Middle Name"
			},
			contactLivesWithStudentText: {
				type: String,
				default: "Contact Lives With Student"
			},
			yesText: {
				type: String,
				default: "Yes"
			},
			noText: {
				type: String,
				default: "No"
			},
			releaseStatusText: {
				type: String,
				default: "Release Status"
			},
			addressOneText: {
				type: String,
				default: "Address 1"
			},
			addressTwoText: {
				type: String,
				default: "Address 2"
			},
			cityText: {
				type: String,
				default: "City"
			},
			stateText: {
				type: String,
				default: "State"
			},
			numberText: {
				type: String,
				default: "Number"
			},
			extensionText: {
				type: String,
				default: "Ext."
			},
			typeText: {
				type: String,
				default: "Type"
			},
			cellPhoneText: {
				type: String,
				default: "Cell Phone"
			},
			faxNumberText: {
				type: String,
				default: "Fax Number"
			},
			homePhoneText: {
				type: String,
				default: "Home Phone"
			},
			pageNumberText: {
				type: String,
				default: "Pager Number"
			},
			workPhoneText: {
				type: String,
				default: "Work Phone"
			},
			unlistedText: {
				type: String,
				default: "Unlisted"
			},
			receivesVoiceCallsText: {
				type: String,
				default: "Receives Voice Calls"
			},
			receivesTextMessages: {
				type: String,
				default: "Receives Text Messages"
			},
			emergencyCallOrder: {
				type: String,
				default: "Emergency Call Order"
			},
			emailText: {
				type: String,
				default: "Email"
			},
			occupationText: {
				type: String,
				default: "Occupation"
			},
			employerText: {
				type: String,
				default: "Employer"
			},
			zipCodeText: {
				type: String,
				default: "Zip Code"
			},
			zipCodeExtText: {
				type: String,
				default: "Zip Code Ext"
			},
			townshipText: {
				type: String,
				default: "Township"
			},
			countyText: {
				type: String,
				default: "County"
			},
			zipExtMaxLength: {
				type: String | Number,
				default: 4
			},
            isReadOnly:{
                type:Boolean,
                default:false
            }
		},
		components: {
			PanelBasic,
			SapphireToggle,
			FontAwesomeIcon,
			ValidationProvider,
			VTooltip
		}
	}
</script>
